import { isEmpty } from 'lodash';

export const EMAIL_REGEXP = /\S+@\S+\.\S+/;

export const capitalize = (text: string) =>
    text
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
        .replaceAll('_', ' ');

export const equalsIgnoreCase = (stringA: string, stringB: string | null) => {
    return !!(stringA && stringB && stringA.toUpperCase() === stringB.toUpperCase());
};

export const includesIgnoreCase = (arrayString = [], searchString: string | null = null) => {
    const data = arrayString.find((dataString) => equalsIgnoreCase(dataString, searchString));

    return !!data;
};

export const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return !emailRegex.test(email);
};

export const handleCopyLinkToShare = (textToCopy: string) => {
    navigator.clipboard.writeText(textToCopy);
};

export const getAgentFullName = (agent: { firstName?: string | null; lastName?: string | null }) => {
    const { firstName, lastName } = agent || {};
    const trimmedFirstName = `${firstName || ''}`.trim();
    const trimmedLastName = `${lastName || ''}`.trim();

    const spacer = !isEmpty(trimmedFirstName) && !isEmpty(trimmedLastName) ? ' ' : '';

    return `${trimmedFirstName}${spacer}${trimmedLastName}`;
};

export const handleNumberOnlyKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
    options?: { allowDecimals?: boolean }
) => {
    const { allowDecimals = false } = options ?? {};
    const key = event.key;
    const isCtrlA = (event.ctrlKey || event.metaKey) && (key === 'a' || key === 'A');
    const isCtrlV = (event.ctrlKey || event.metaKey) && (key === 'v' || key === 'V');
    const isSpace = key === ' ';
    const excludedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Enter', 'ArrowUp', 'ArrowDown'];

    if (isCtrlA || isCtrlV || excludedKeys.includes(key) || (allowDecimals && key === '.')) {
        return;
    } else if (isNaN(Number(key)) || isSpace) {
        event.preventDefault();
    } else {
        return;
    }
};

export const capitalizeUnderScore = (category: string): string => {
    return category
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const formatPriceRange = ({ minPrice, maxPrice }: { minPrice: number; maxPrice: number }): string => {
    if (minPrice && maxPrice) {
        return `$${minPrice.toLocaleString()} to $${maxPrice.toLocaleString()}`;
    } else if (maxPrice) {
        return `up to $${maxPrice.toLocaleString()}`;
    } else if (minPrice) {
        return `from $${minPrice.toLocaleString()}`;
    } else {
        return 'Price not available';
    }
};
